/* unplugin-vue-components disabled */import { render } from "./VipTryOut.vue?vue&type=template&id=4ab9f391&ts=true"
import script from "./VipTryOut.vue?vue&type=script&lang=ts"
export * from "./VipTryOut.vue?vue&type=script&lang=ts"

import "./VipTryOut.vue?vue&type=style&index=0&id=4ab9f391&lang=scss"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__